module.exports = __webpack_public_path__ + "img/leon-Oalh2MojUuk-unsplash.1acfbdd4.jpeg";